import { useState } from 'react'
import { message } from 'antd'
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import useAxios, { axiosInstance } from '../../../../../hooks/useAxios'
import ImgTag from '../../../../../components/ImgTag'
import FacebookIcon from '@mui/icons-material/Facebook';
import { ERRORS_MESSAGE_MAPPER } from '../../../../../constants/errors';

interface IFacebookPageConnected {
  _id: string;
  pageId: string;
  accessToken: string;
  createdAt: string;
  imageUrl: string;
  merchant: string;
  objectId: string;
  pageName: string;
  updatedAt: string;
}

interface IFacebookPage {
  access_token: string;
  id: string;
  category: string;
  name: string;
  image: string;
}
interface FacebookSettingChatProps {
  isLoginFacebook: boolean;
}

const FacebookSettingChat = ({ isLoginFacebook }: FacebookSettingChatProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [anchorElListPageMenu, setAnchorElListPageMenu] = useState<null | HTMLElement>(null)
  const openListPageMenu = Boolean(anchorElListPageMenu)

  const onHandleLoginFacebook = async () => {
    setIsLoading(true)
    try {
      const currentUrl = window.location.href
      const response = await axiosInstance.get<{ url: string }>(`/facebook/login?redir=${currentUrl}`)
      setTimeout(() => {
        window.location.href = response.data.url
      }, 1500)
    } catch (e: any) {
      const messageError = ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] || 'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
    setIsLoading(false)
  }

  const onHandleLogoutFacebook = async () => { }

  const onHandleAddPage = async (newPage: IFacebookPage) => {
    setIsLoading(true)
    try {
      await axiosInstance.post('/facebook/pages/connect', {
        pages: [
          {
            accessToken: newPage.access_token,
            pageId: newPage.id,
            pageName: newPage.name,
            imageUrl: newPage.image,
          }
        ]
      })
      await pageListConnected.mutate()
      message.success('เพิ่มเพจสำเร็จ')
    } catch (e: any) {
      const messageError = ERRORS_MESSAGE_MAPPER?.[e.response?.data?.message ?? ''] || 'บันทึกข้อมูลไม่สำเร็จ'
      message.error(messageError)
    }
    setIsLoading(false)
  }

  const pageListConnected = useAxios<IFacebookPageConnected[]>({
    method: 'GET',
    url: '/facebook/pages/available',
  })

  const pageList = useAxios<IFacebookPage[]>({
    method: 'GET',
    url: '/facebook/pages',
  })

  return (
    <>
      <Card sx={{
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
      }}>
        <Box
          sx={{ marginBottom: 2 }}
        >
          <Typography variant="h3">
            {isLoginFacebook ? "เลือกเพจที่ต้องการ 1-4 เพจ" : "เข้าสู่ระบบ Facebook"}
          </Typography>
        </Box>
        <Box sx={{ width: "50%", marginBottom: 2 }}>
          <Grid container spacing={2}
            alignItems={"flex-start"}
            justifyContent={"center"}
          >
            {
              pageListConnected.data?.map((page) => (
                <Grid item xs={6} md={6} lg={3} key={page._id}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <ImgTag
                      imageUrl={page.imageUrl}
                      name={page.pageName}
                      size={isMobile ? 70 : 100}
                      isShowCancel={true}
                      onCancel={() => null}
                    />
                    <Box
                      sx={{ marginTop: "4px" }}
                    >
                      <Typography variant="h6">{(page.pageName.length > 5 && isMobile) ? page.pageName.substring(0, 5) + '...' : page.pageName}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))
            }
            {
              pageListConnected.data?.length! < 4 && (
                <Grid item xs={6} md={6} lg={3}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center", height: isMobile ? 70 : 145 }}>
                    <IconButton
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: isMobile ? 70 : 100,
                        height: isMobile ? 70 : 100,
                        cursor: "pointer",
                      }}
                      onClick={(event) => setAnchorElListPageMenu(event.currentTarget)}
                    >
                      <AddCircleIcon sx={{ fontSize: 50 }} color={"disabled"} />
                    </IconButton>
                    <Menu
                      anchorEl={anchorElListPageMenu}
                      open={openListPageMenu}
                      onClose={() => setAnchorElListPageMenu(null)}
                    >
                      {
                        pageList.isLoading ?
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                            }}
                          >
                            <CircularProgress />
                          </Box>
                          :
                          <>
                            {
                              pageList.data?.map((item: IFacebookPage, index: number) => (
                                <MenuItem key={index}
                                  disabled={!!pageListConnected.data?.find((page) => page.pageId === item.id)}
                                  onClick={() => {
                                    setAnchorElListPageMenu(null)
                                    onHandleAddPage(item)
                                  }}>
                                  <ImgTag imageUrl={item.image}
                                    name={item.name} size={30} />
                                  <ListItemText sx={{ marginLeft: 1 }}>{item.name}</ListItemText>
                                </MenuItem>
                              ))
                            }
                          </>
                      }
                    </Menu>
                    <Box
                      sx={{ marginTop: "20px" }}
                    >
                      <Typography variant="h6" color="text.disabled">เพิ่มเพจ</Typography>
                    </Box>
                  </Box>
                </Grid>
              )
            }
          </Grid>
        </Box>
        <Box>
          {isLoginFacebook ?
            <Button variant="outlined" color={"error"} size="large" startIcon={<LogoutIcon />}
              onClick={onHandleLogoutFacebook}>
              ออกจากระบบ Facebook
            </Button>
            :
            <Button variant="contained" size="large" startIcon={<FacebookIcon />} color={'info'}
              onClick={onHandleLoginFacebook}>
              เข้าสู่ระบบ Facebook
            </Button>
          }
        </Box>
      </Card >
    </>
  )
}

export default FacebookSettingChat